import { MyProductsViewToggle } from "./components/my-products-view-toggle";
import { useMyProductsViewStore } from "./store/useMyProductsViewStore";
import { useDashboardFilters } from "../../store/useDashboardFilters";
import { DashboardChartProductUsage } from "../dashboard-chart-product-usage";
import { DashboardChartProductCompetency } from "../dashboard-chart-product-competency";
import { useTranslation } from "react-i18next";

export function DashboardMyProductsView() {
  const { viewMode, setViewMode } = useMyProductsViewStore();
  const filters = useDashboardFilters((s) => s.filters);
  const [translate] = useTranslation(["dashboard"]);

  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-lg font-medium text-zinc-900">
        {translate("dashboard-my-products-view-title")}
      </h2>

      <MyProductsViewToggle mode={viewMode} onChange={setViewMode} />

      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-1 gap-4">
          <DashboardChartProductUsage
            startDate={filters.startDate}
            endDate={filters.endDate}
            city={filters.cities ?? undefined}
            group_id={filters.group_id ?? undefined}
            type={filters.type ?? undefined}
            status={filters.status ?? undefined}
            users={filters.users ?? undefined}
            spaces={filters.spaces ?? undefined}
            viewMode={viewMode}
          />
          <DashboardChartProductCompetency
            startDate={filters.startDate}
            endDate={filters.endDate}
            city={filters.cities ?? undefined}
            group_id={filters.group_id ?? undefined}
            type={filters.type ?? undefined}
            status={filters.status ?? undefined}
            users={filters.users ?? undefined}
            spaces={filters.spaces ?? undefined}
            viewMode={viewMode}
          />
        </div>
      </div>
    </div>
  );
}
